// Web Push (W3C): Service Worker + Push API + VAPID. Riusa il backend notify()/send_push().
import { apiFetch } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) output[i] = raw.charCodeAt(i);
  return output;
}

export function webPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function registerServiceWorker() {
  if (!webPushSupported()) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js");
  } catch {
    return null;
  }
}

// Stato attuale: push attivo se permesso concesso E subscription presente nel browser.
export async function webPushEnabled() {
  if (!webPushSupported() || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    return !!sub;
  } catch {
    return false;
  }
}

// Idempotente. interactive=false (es. al login): NON chiede il permesso; si sottoscrive solo se già concesso.
// interactive=true: su iOS/Safari/PWA il popup nativo deve partire DIRETTAMENTE dal gesto utente,
// quindi Notification.requestPermission() va chiamato PRIMA di qualsiasi await (prima del Service Worker).
export async function enableWebPush(interactive = false) {
  if (!webPushSupported()) return { ok: false, reason: "unsupported" };
  let permission = Notification.permission;
  if (permission === "default") {
    if (!interactive) return { ok: false, reason: "default" };
    permission = await Notification.requestPermission();
  }
  if (permission !== "granted") return { ok: false, reason: permission };
  const reg = await registerServiceWorker();
  if (!reg) return { ok: false, reason: "sw-failed" };
  const { public_key: publicKey } = await apiFetch("/push/vapid-public-key").catch(() => ({ public_key: "" }));
  if (!publicKey) return { ok: false, reason: "no-vapid" };
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  const json = sub.toJSON();
  await apiFetch("/push/web/subscribe", {
    method: "POST",
    body: JSON.stringify({ endpoint: json.endpoint, keys: json.keys }),
  });
  return { ok: true };
}

// Logout / cambio account: annulla la subscription e la rimuove dal backend.
export async function disableWebPush() {
  if (!webPushSupported()) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    await apiFetch("/push/web/unsubscribe", {
      method: "POST",
      body: JSON.stringify({ endpoint: sub.endpoint }),
    }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  } catch {
    /* best-effort */
  }
}
